import React from 'react'
import Header from '../Header/Header'
import Banner from '../WashingMachine/Banner'
import Banner2 from '../Banner2/Banner2'
import Banner3 from '../Banner3/Banner3'
import Banner4 from '../LED_TV Banner/Banner4'
import MixerGrinder from '../MixerGrinder/MixerGrinder'
import Acproduct from '../Acproduct/Acproduct'
import SelectProduct from '../SelectProduct/SelectProduct'
import Shoping from '../Shoping/Shoping'
// import YouTube from '../YouTube/YouTube'
import Acside from '../Acside/Acside'
import Acbanner from '../Acbanner/Acbanner'
import Aircooler from '../Aircooler/Aircooler'
// import ElectronicsAppliances from '../HomeAppliances/HomeAppliances'

const Home = () => {
  return (
    <div>
      <SelectProduct /> 
        <Header /> 
        {/* <Neeew/> */}
        {/* <NewLounch />  */}
        {/* <ElectronicsAppliances/> */}
        <Banner />
        {/* <NewPage/> */}
        <Acside/>
        <Aircooler/>
        <Acbanner/>
        <Acproduct/>
        <Banner2 />
        <Banner3 />
        <Banner4 />
        <MixerGrinder />
        <Shoping/>
        {/* <YouTube /> */}
    </div>
  )
}

export default Home